import React, { useState, useEffect } from "react";
import "../styles/Resume.css";

export default function Resume() {
  const certifications = [
    {
      year: "2025",
      title: "Foundation of UX Design",
      place: "Coursera",
      desc: "Basic UX design, wireframing, usability testing.",
      image: "/images/Coursera01.jpg",
    },
    {
      year: "2025",
      title: "Introduction to UI/UX Design",
      place: "Coursera",
      desc: "Advanced UI/UX design, usability testing.",
      image: "/images/Coursera03.jpg",
    },
    {
      year: "2025",
      title: "Agile Development and Scrum",
      place: "Coursera",
      desc: "Strong foundation in agile development.",
      image: "/images/Coursera02.jpg",
    },
    {
      year: "2025",
      title: "Wireframe UX Design",
      place: "Coursera",
      desc: "Build wireframes and low-fidelity prototypes.",
      image: "/images/Coursera04.jpg",
    },
    {
      year: "2025",
      title: "UX Research",
      place: "Coursera",
      desc: "Conduct UX research and test early concepts.",
      image: "/images/Coursera05.jpg",
    },
    {
      year: "2025",
      title: "UX Design Process",
      place: "Coursera",
      desc: "Empathize, define and ideate UX solutions.",
      image: "/images/Coursera06.jpg",
    },
  ];

  const [selectedImage, setSelectedImage] = useState(null);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);

  // Responsive visible cards
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 600) {
        setVisibleCount(1);
      } else if (window.innerWidth <= 1024) {
        setVisibleCount(2);
      } else {
        setVisibleCount(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePrev = () => {
    setCarouselIndex((prev) =>
      prev - visibleCount < 0 ? 0 : prev - visibleCount
    );
  };

  const handleNext = () => {
    setCarouselIndex((prev) =>
      prev + visibleCount >= certifications.length
        ? prev
        : prev + visibleCount
    );
  };

  return (
    <section id="resume" className="resume">
      <div className="resume-header">
        <h2>Education & Certifications</h2>
        <p>Continuous learning to improve my skills and expertise</p>
      </div>

      <div className="resume-vertical">
        {/* EDUCATION */}
        <div className="resume-card">
          <img src="/images/ousl.jpg" alt="Education" className="certificate-img" />
          <span className="resume-year">2021 – Present</span>
          <div className="card-content">
            <h3>BSE (Hons) in Software Engineering</h3>
            <h4>The Open University of Sri Lanka</h4>
            <p>
              Focused on software engineering, UI/UX design, database systems
              and business analysis with strong practical exposure.
            </p>
          </div>
        </div>

        {/* CERTIFICATE CAROUSEL */}
        <div className="carousel-container">
          <button className="carousel-btn prev" onClick={handlePrev}>
            &#10094;
          </button>

          <div className="carousel-slide">
            {certifications
              .slice(carouselIndex, carouselIndex + visibleCount)
              .map((cert, idx) => (
                <div
                  key={idx}
                  className="resume-card certificate-card"
                  onClick={() => setSelectedImage(cert.image)}
                >
                  <img
                    src={cert.image}
                    alt={cert.title}
                    className="certificate-img"
                  />
                  <span className="resume-year">{cert.year}</span>
                  <div className="card-content">
                    <h3>{cert.title}</h3>
                    <h4>{cert.place}</h4>
                    <p>{cert.desc}</p>
                  </div>
                </div>
              ))}
          </div>

          <button className="carousel-btn next" onClick={handleNext}>
            &#10095;
          </button>
        </div>
      </div>

      {/* IMAGE MODAL */}
      {selectedImage && (
        <div className="modal" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Certificate Preview" />
        </div>
      )}
    </section>
  );
}